import React from "react";
import { useParams } from "react-router-dom";
import BookingProcess from "./BookingProcess";
import FloatingCartButonBooking from "./FloatingCartButonBooking";

const BookingMain = () => {
  const { slug } = useParams();
  return (
    <>
      <BookingProcess slug={slug} />
      <FloatingCartButonBooking />
    </>
  );
};

export default BookingMain;
